var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "landingWrapper" } },
    [
      _c("section", { staticClass: "section-main max-width--large" }, [
        _c("div", { staticClass: "headerWrapper" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("p", { staticClass: "describtionText mb-12" }, [
            _vm._v(
              "\n        Nutzen Sie die Chancen der digitalen Technologien, angefangen von\n        effizienteren Prozessen über eine höhere Kundenzufriedenheit bis hin\n        zur Entwicklung neuer Geschäftsmodelle\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button__Wrapper" },
            [
              !_vm.loggedIn
                ? _c(
                    "v-btn",
                    {
                      staticClass: "CTA",
                      attrs: {
                        color: "primary",
                        large: "",
                        elevation: "0",
                        to: "/register"
                      }
                    },
                    [_vm._v("\n          Registrieren\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "CTA",
                  attrs: {
                    color: "secondary",
                    large: "",
                    elevation: "0",
                    to: "/news"
                  }
                },
                [_vm._v("\n          News\n        ")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "section-mainFeature max-width--large" },
        [
          _c(
            "MainFeatureCard",
            {
              attrs: {
                headline: "Business-Model-Canvas Generator",
                featureText:
                  "Systematisieren Sie ihr Geschäftsmodell mit dem Business Model Canvas Generator",
                featureLink: "/bm/menu",
                ctaText: "Ihr Business modellieren"
              }
            },
            [
              _c("v-img", {
                attrs: {
                  src: _vm.bmcIcon,
                  "max-height": "8.75rem",
                  "max-width": "12.5rem"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "MainFeatureCard",
            {
              attrs: {
                headline: "KI-Readiness-Check",
                featureText:
                  "Messen Sie den KI-Reifegrad ihres Unternehmens und erhalten Sie individuelle Empfehlungen",
                featureLink: "/readiness-welcome",
                ctaText: "Hier gehts zum Check"
              }
            },
            [
              _c("v-img", {
                attrs: {
                  src: _vm.kircIcon,
                  "max-height": "8.75rem",
                  "max-width": "7rem"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "MainFeatureCard",
            {
              attrs: {
                headline: "Lern- und Aktionsplattform",
                featureText:
                  "Lernen Sie online wie sie die digitale Transformation für ihr Unternehmen nutzen",
                isExternal: "true",
                extenalLink: "https://lea.ita-kl.de/dmz/",
                ctaText: "Jetzt kostenlos registrieren"
              }
            },
            [
              _c("v-img", {
                attrs: {
                  src: _vm.leaIcon,
                  "max-height": "8.75rem",
                  "max-width": "12.5rem"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "section-secondaryFeatures ma-3" }, [
        _c(
          "div",
          {
            staticClass:
              "secondaryFeature_Wrapper pa-10 pa-sm-12 pa-lg-16 max-width--large"
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cardsWrapper grid" },
              [
                _c(
                  "FeatureCard",
                  {
                    attrs: {
                      featureText: "Informieren Sie sich über Technologien",
                      featureLink: "/search/technology"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/landing-icons/werner_tech_icon.svg"),
                        alt: "Feature Icon"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "FeatureCard",
                  {
                    attrs: {
                      featureText: "Finden Sie Projekt-Partner",
                      featureLink: "/profile/partners"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/landing-icons/werner_partner_icon.svg"),
                        alt: "Feature Icon"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "FeatureCard",
                  {
                    attrs: {
                      featureText: "Erstellen Sie Ihr Unternehmensprofil",
                      featureLink: "/profile/create"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/landing-icons/werner_company_icon.svg"),
                        alt: "Feature Icon"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "FeatureCard",
                  {
                    attrs: {
                      featureText: "Suchen Sie nach KI-Trainern",
                      featureLink: "/search/kitrainer"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/landing-icons/werner_search_icon.svg"),
                        alt: "Feature Icon"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "FeatureCard",
                  {
                    attrs: {
                      featureText:
                        "Lassen Sie sich durch Projektbeispiele inspirieren",
                      featureLink: "/search/referenceproject"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/landing-icons/werner_project_icon.svg"),
                        alt: "Feature Icon"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "FeatureCard",
                  {
                    attrs: {
                      featureText: "Suchen Sie nach Veranstaltungen",
                      featureLink: "/search/event"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/landing-icons/werner_cal_icon.svg"),
                        alt: "Feature Icon"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "FeatureCard",
                  {
                    attrs: {
                      featureText:
                        "Informieren Sie sich über Digitale Angebote",
                      featureLink: "/search/offer"
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/landing-icons/werner_digital_offer_icon.svg"),
                        alt: "Feature Icon"
                      }
                    })
                  ]
                )
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.cookieAccept },
          on: {
            "update:mdActive": function($event) {
              _vm.cookieAccept = $event
            },
            "update:md-active": function($event) {
              _vm.cookieAccept = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px" } },
            [
              _c("md-dialog-title", [_vm._v("WERNER benutzt Cookies")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  '\n          Cookies sind Textdateien, welche über einen Internetbrowser auf\n          einem Computersystem abgelegt und gespeichert werden. Zahlreiche\n          Internetseiten und Server verwenden Cookies. Viele Cookies enthalten\n          eine sogenannte Cookie-ID. Eine Cookie-ID ist eine eindeutige\n          Kennung des Cookies. Diese ermöglicht es den besuchten\n          Internetseiten und Servern, den individuellen Browser der\n          betroffenen Person von anderen Internetbrowsern, die andere Cookies\n          enthalten, zu unterscheiden. Durch den Einsatz von Cookies kann die\n          DFKI GmbH den Nutzern dieser Internetseite nutzerfreundlichere\n          Services bereitstellen, die ohne die Cookie-Setzung nicht möglich\n          wären. Mit einem Klick auf "Akzeptieren", wird bei weiterem Besuch\n          der Webseite von Ihrer Einwilligung in die Verwendung von Cookies\n          ausgegangen. Mehr Informationen zu unserem Datenschutz finden Sie\n          unter\n          '
                ),
                _c("i", [_vm._v("Datenschutzerlärung")]),
                _vm._v(" in der Fußleiste.\n        ")
              ]),
              _vm._v(" "),
              _c(
                "md-dialog-actions",
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary",
                      on: {
                        click: function($event) {
                          _vm.first = false
                          _vm.setBeenHere()
                        }
                      }
                    },
                    [_vm._v("Akzeptieren")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h1",
      { staticClass: "mainHeadline my-6 my-md-8 my-md-8 my-lg-10 my-xl-10" },
      [_vm._v("WERNER"), _c("br"), _vm._v("Netzwerk für Innovation")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "secondaryFeature_intro" }, [
      _c("h2", { staticClass: "pb-8 h2--landing" }, [
        _vm._v(
          "\n            Nutzen Sie die Chancen der digitalen Transformation für ihr\n            Unterhehmen\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "pb-8" }, [
        _vm._v(
          "\n          Probieren Sie unsere kostenlosen Digitalisierungstools aus. Lernen Sie \n          neue Technologien kennen, vernetzen Sie sich mit interessanten Unternehmen \n          oder lassen Sie sich von innovativen Beispiel-Projekten inspirieren.\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ad4ac9f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ad4ac9f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing/Landing.vue
// module id = null
// module chunks = 